export const FilterSettingsConstants = {
  S: { xs: 12, sm: 6, md: 4, lg: 3 },
  M: { xs: 12, sm: 12, md: 6, lg: 4 },
  L: { xs: 12, sm: 12, md: 8, lg: 6 }
};
